import React from 'react'
import './Slider.css'
import slider_0 from '../images/slider_0.png'
import slider_1 from '../images/slider_1.png'
import slider_2 from '../images/slider_2.jpg'
import slider_3 from '../images/slider_3.jpg'
import slider_4 from '../images/slider_7.png'
import slider_5 from '../images/slider_5.jpg'
import slider_6 from '../images/slider_6.png'
import slider_8 from '../images/slider_8.png'
import slider_9 from '../images/slider_9.png'
import slider_10 from '../images/slider_10.png'
import slider_11 from '../images/slider_11.png'
import slider_12 from '../images/slider_12.png'
import slider_13 from '../images/slider_13.png'
import slider_14 from '../images/slider_14.png'
import slider_15 from '../images/slider_15.png'
import slider_16 from '../images/slider_16.png'
import slider_17 from '../images/slider_17.png'
import slider_18 from '../images/slider_18.png'
import slider_19 from '../images/slider_19.png'
import slider_20 from '../images/slider_20.png'
import slider_21 from '../images/slider_21.png'
import slider_22 from '../images/slider_22.png'
import slider_23 from '../images/slider_23.png'
import slider_24 from '../images/slider_24.png'
import slider_25 from '../images/slider_25.png'
import slider_26 from '../images/slider_26.png'
import slider_27 from '../images/slider_27.png'
import slider_28 from '../images/slider_28.png'
import slider_29 from '../images/slider_29.png'
import slider_30 from '../images/slider_30.png'
import slider_31 from '../images/slider_31.png'
import slider_32 from '../images/slider_32.png'
import slider_33 from '../images/slider_33.png'
import slider_34 from '../images/slider_34.png'
import slider_35 from '../images/slider_35.png'


function Slider() {
  return (
    <div className="container my-5">
        <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src={slider_0} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_1} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_2} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_3} class="d-block w-100" alt="..." />
              </div> 
              <div class="carousel-item">
                <img src={slider_4} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_5} class="d-block w-100" alt="..." />
              </div>
              {/* <div class="carousel-item">
                <img src={slider_6} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_8} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_9} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_10} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_11} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_12} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_13} class="d-block w-100" alt="..." />
              </div> */}
              <div class="carousel-item">
                <img src={slider_14} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_15} class="d-block w-100" alt="..." />
              </div>
              {/* <div class="carousel-item">
                <img src={slider_16} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_17} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_18} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_19} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_20} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_21} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_22} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_23} class="d-block w-100" alt="..." />
              </div> */}
              <div class="carousel-item">
                <img src={slider_24} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_25} class="d-block w-100" alt="..." />
              </div>
              {/* <div class="carousel-item">
                <img src={slider_26} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_27} class="d-block w-100" alt="..." />
              </div> */}
              <div class="carousel-item">
                <img src={slider_28} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_29} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_30} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_31} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_32} class="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src={slider_33} class="d-block w-100" alt="..." />
              </div>
              {/* <div class="carousel-item">
                <img src={slider_34} class="d-block w-100" alt="..." />
              </div> */}
              {/* <div class="carousel-item">
                <img src={slider_35} class="d-block w-100" alt="..." />
              </div> */}
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
    </div>
  )
}

export default Slider